import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';

@Component({
  selector: 'app-resource-tray-card',
  templateUrl: './resource-tray-card.component.html',
  styleUrls: ['./resource-tray-card.component.css'],
})
export class ResourceTrayCardComponent implements AfterViewInit, OnDestroy {
  @ViewChild('metadata') private metadata?: ElementRef<HTMLElement>;
  @ViewChild('card') private card?: ElementRef<HTMLElement>;

  private metadataResizeObserver?: ResizeObserver;

  ngAfterViewInit(): void {
    const metadata = this.metadata?.nativeElement;
    const card = this.card?.nativeElement;
    if (!metadata || !card) {
      return;
    }
    this.metadataResizeObserver = new ResizeObserver(([entry]) => {
      card.style.setProperty('--resource-tray-card-metadata-height', `${entry.contentRect.height}px`);
    });
    this.metadataResizeObserver.observe(metadata);
  }

  ngOnDestroy(): void {
    this.metadataResizeObserver?.disconnect();
  }
}
